<template>
  <div class="menu-compselector">
    <div class="selected">
      <div class="company">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <circle cx="11" cy="11" r="10" stroke="#222222" stroke-width="1.5"/>
          <path d="M6.5 16C8.8317 13.5578 13.1432 13.4428 15.5 16M13.4951 8.5C13.4951 9.88071 12.3742 11 10.9915 11C9.60885 11 8.48797 9.88071 8.48797 8.5C8.48797 7.11929 9.60885 6 10.9915 6C12.3742 6 13.4951 7.11929 13.4951 8.5Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <div class="company_text" v-show="!hided_menu">
          <span class="desc">{{currentCounterparty.type}}</span>
          <span class="value">{{currentCounterparty.title}}</span>
        </div>
      </div>
      <svg v-show="!hided_menu" class="change_company" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M5.8335 8.33331L10.0002 11.6666L14.1668 8.33331" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <div class="selector">

    </div>

  </div>
</template>

<script>



export default {
  name : "MenuCompselector",
  props : {
    hided_menu : Boolean,
    currentCounterparty : Object
  },
  data() {
    return{

    }
  }
}
</script>

<style scoped>
.menu-compselector {
  border-radius: 8px;
  background: var(--BG, #F8F8F8);
  padding: 11px 10px 11px 12px;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
  cursor: pointer;
}

.menu-compselector .selected {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 24px;
}

.menu-compselector .selected .change_company {

}

.menu-compselector .selected .company {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

.menu-compselector .selected .company_text {
  display: flex;
  flex-direction: column;
}

.menu-compselector .selected .company_text .desc{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  opacity: 0.7;
}

.menu-compselector .selected .company_text .value{
  overflow: hidden;
  color: var(--Black, #222);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 124%;
}

.menu-compselector .selector {

}
</style>